import React, { useRef, useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import Close from "./Path.png";
import styles from "./modal.scss";
import { getPdmApiUrl } from "../../utils/helper";
import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import find from "lodash/find";
import NewSpinner from "@tw/shared-ui-components/lib/components/newSpinner/newSpinner";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";
import DialogModal from "../DialogModal/DialogModal";
import Portal from "@tw/shared-ui-components/lib/components/portal/portal";

const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(44, 44, 44, 0.6);
  backdrop-filter: blur(3px);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  @media screen and (max-width: 1024px) {
    top: 0;
    left: 0;
    z-index: 9999;
    position: fixed;
    background: rgba(44, 44, 44, 1);
  }
  @media screen and (min-width: 1200px) {
    // margin-left: -54px;
    // margin-top: -25px;
    // top: 25px;
    top: 0;
    left: 0;
    z-index: 9999;
    position: fixed;
  }
`;

const ModalWrapper = styled.div`
  width: 460px;
  height: 343px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  position: relative;

  position: relative;
  z-index: 99999999999;
  @media screen and (min-width: 993px) {
    width: 460px;
    height: 343px;
    z-index: 99999999999;
    border-radius: 10px;
  }
`;

function Modal(props) {
  const {
    showModal,
    setShowModal,
    selectedProductIds,
    setSelectedProductIds,
    setdisplaySelectOption,
    toggle,
    setToggle,
    setDisableAddToCart,
    productCode,
    // createList,
  } = props; // for popup window
  const [isInput, setInput] = useState(false);
  const [items, setItem] = useState(false);
  const [isRadioCheck, setRadioCheck] = useState(false); // it is for checkbox of existing list
  const [listTitle, setListTitle] = useState("");
  const [shareList, setShareList] = useState([]);
  const [selectedShareId, setSelectedShareId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDialogModal, setShowDialogModal] = useState(false);
  const [listAction, setListAction] = useState("");
  // const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [showContent, setShowContent] = useState(true);
  // const [isError, setIsError] = useState(false);

  const openModal = () => {
    setShowDialogModal((prev) => !prev);
  };

  useEffect(() => {
    if (!toggle) {
      setInput(false);
      setItem(false);
      setSelectedShareId("");
    }
  }, [toggle]);

  const selectedProducts = productCode
    ? [...selectedProductIds, productCode]
    : selectedProductIds;

  const onExceedingListNameLimit = () => {
    setIsLoading(false);
    setShowContent(true);
    setShowModal(false);
    toastMsg("上限為 20 字", null, "default_error_one_line");
    setListTitle("");
  };

  const addToList = async (action) => {
    setIsLoading(true);
    setShowContent(false);
    let title;
    if (action === "createList")
      title = listTitle.length < 21 ? listTitle : onExceedingListNameLimit();
    else title = find(shareList, { shareId: selectedShareId })?.title;

    const defaultDescription = "專屬推薦給您的安麗好物!";
    const description = find(shareList, {
      shareId: selectedShareId,
    })?.description;

    if (!title) return;
    setInput(false);

    const ListproductCount =
      action === "updateList"
        ? (find(shareList, { shareId: selectedShareId })?.productList).length
        : null;

    action === "createList"
      ? setListAction("createList")
      : setListAction("updateList");

    if (
      action === "createList" ||
      (action === "updateList" &&
        ListproductCount + selectedProducts.length <= 10)
    ) {
      const payload = {
        skuCodes: selectedProducts,
        title: title,
        description: description || defaultDescription,
        shareId: action === "createList" ? "" : selectedShareId,
      };

      const apiUrl = getPdmApiUrl();
      await axios
        .post(`/plp/share-list`, payload, {
          baseURL: apiUrl,
        })
        .then(() => {
          setSelectedProductIds && setSelectedProductIds([]);
          setInput(false);
          setListTitle("");
          setdisplaySelectOption && setdisplaySelectOption(false);
          setToggle && setToggle(!toggle);
          setDisableAddToCart && setDisableAddToCart(false);
          setRadioCheck(false);
          setIsLoading(false);
          // setShowModal && setShowModal(false);
          openModal();
          setShowContent(true);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
          setSelectedProductIds && setSelectedProductIds([]);
          setdisplaySelectOption && setdisplaySelectOption(false);
          setToggle && setToggle(!toggle);
          setShowModal && setShowModal(false);
          setShowContent(true);
          if (action === "createList") {
            toastMsg("新增清單操作失敗");
          } else toastMsg("更新清單操作失敗");
        });
    } else {
      toastMsg("打包清單最多添加10個商品", null, "default_error_one_line");
      // setIsError(true);
      //setShowErrorDialog(true);
      setInput(false);
      setListTitle("");
      setDisableAddToCart && setDisableAddToCart(false);
      setIsLoading(false);
      setShowModal && setShowModal(false);
      setShowContent(true);
    }
  };

  const handleTitleChange = (e) => {
    setRadioCheck(false);
    setListTitle(e.target.value);
  };

  const modalRef = useRef();

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false);
      setInput(false);
      setItem(false);
      setRadioCheck(false);
    }
  };

  const continueHandleClick = () => {
    addToList("updateList");
    // setdisplaySelectOption && setdisplaySelectOption(false);
    // setToggle && setToggle(!toggle);
    // setSelectedProductIds && setSelectedProductIds([]);
    setItem(false);
    setRadioCheck(false);
  };

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false);
        setInput(false);
        setItem(false);
        setRadioCheck(false);
      }
    },
    [setShowModal, showModal]
  );

  const onClickHandler = () => {
    setInput(false);
    setItem(true);
    setIsLoading(true);

    const apiUrl = getPdmApiUrl();
    axios
      .post(
        `/plp/query-share-list-customer`,
        {},
        {
          baseURL: apiUrl,
        }
      )
      .then((res) => {
        setShareList(
          res?.data?.shareList?.filter(
            (shareListItem) => shareListItem.status == 1
          )
        );
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  if (!showModal) return null;

  const isFirefox = typeof InstallTrigger !== "undefined";

  return (
    <Portal>
      {showModal && (
        <Background onClick={closeModal} ref={modalRef}>
          <ModalWrapper showModal={showModal}>
            {showContent && (
              <>
                <div className={styles["main-head"]}>
                  <div className={styles["Wrapper"]}>選擇要加入的打包清單</div>
                  <img
                    src={Close}
                    alt=""
                    className={styles["close"]}
                    onClick={() => {
                      setShowModal((prev) => !prev);
                      setInput(false);
                      setItem(false);
                      setRadioCheck(false);
                    }}
                  />
                </div>
                <div className={styles["list"]}>
                  <div className={styles["create-list"]}>
                    <div className={styles["radio_options"]}>
                      <div
                        className={`${styles["select_radio"]} ${isInput ? styles["active"] : ""
                          }`}
                      >
                        <label className={styles["labl"]}>
                          <input
                            type="radio"
                            name="radio_btns"
                            // disabled={!isValidVariant(variantIndex, value.value)}
                            onChange={() => {
                              setInput(true);
                              setItem(false);
                            }}
                          />
                          <span className={styles["radio"]}></span>
                          <span className={styles["text"]}>新增一份清單</span>
                        </label>
                      </div>
                    </div>
                    <div
                      className={
                        isInput === true
                          ? styles["input-visible"]
                          : styles["notvisible"]
                      }
                    >
                      <div className={styles["text"]}>輸入新建清單名字</div>
                      <div className={styles["input_text"]}>
                        <input
                          type="text"
                          id="inputtext"
                          value={listTitle}
                          onChange={handleTitleChange}
                        />

                        <button
                          className={`${styles["createList-btn"]} ${!listTitle.length ? styles["disabled"] : ""
                            }`}
                          onClick={() => {
                            if (!listTitle.length) return;
                            addToList("createList");
                          }}
                        >
                          確認
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={styles["old-list"]}>
                    <div className={styles["radio_options"]}>
                      <div
                        className={`${styles["select_radio"]} ${items ? styles["active"] : ""
                          }`}
                      >
                        <label className={styles["labl"]}>
                          <input
                            type="radio"
                            name="radio_btns"
                            // disabled={!isValidVariant(variantIndex, value.value)}
                            onChange={onClickHandler}
                          />
                          <span className={styles["radio"]} />
                          <span className={styles["text"]}>加入現有清單</span>
                        </label>
                      </div>
                    </div>

                    <div
                      className={
                        items === true
                          ? styles["visible-list"]
                          : styles["not-visible-list"]
                      }
                    >
                      <div className={styles["checkbox-list"]}>
                        {isLoading && (
                          <div className={styles["list_spinner"]}>
                            <NewSpinner />
                          </div>
                        )}
                        {!isLoading &&
                          (shareList?.length > 0 ? (
                            shareList?.map((item, index) => (
                              <CheckboxItem
                                key={index}
                                item={item}
                                index={index}
                                setRadioCheck={setRadioCheck}
                                setSelectedShareId={setSelectedShareId}
                                isRadioCheck={isRadioCheck}
                                selectedShareId={selectedShareId}
                              />
                            ))
                          ) : (
                            <span className={styles["not-sharelist"]}>
                              未找到列表
                            </span>
                          ))}
                      </div>
                      <button
                        onClick={continueHandleClick}
                        className={`${selectedShareId
                            ? styles["button-style"]
                            : styles["not-button"]
                          } ${isFirefox ? styles["isFirefox"] : ""}`}
                      >
                        下一步
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
            {!showContent && isLoading ? (
              <div className={styles["spinner_div"]}>
                <NewSpinner />
              </div>
            ) : null}
          </ModalWrapper>
        </Background>
      )}
      <DialogModal
        showModal={showDialogModal}
        setShowModal={setShowDialogModal}
        setListAction={setListAction}
        setModalState={setShowModal}
        listAction={listAction}
      />
      {/* <DialogModal */}
      {/* // showModal={showErrorDialog} */}
      {/* // setShowModal={setShowErrorDialog} */}
      {/* // isError={isError} */}
      {/* // errorMessage="商品總數超過上限" */}
      {/* // /> */}
    </Portal>
  );
}

const CheckboxItem = ({
  item,
  setSelectedShareId,
  setRadioCheck,
  index,
  isRadioCheck,
  selectedShareId,
}) => {
  return (
    <div className={styles["existing-lists"]}>
      {/* <input
        type="radio"
        name="existing-radio"
        id={`check-${index}`}
        value="1"
        onChange={() => {
          setRadioCheck(true), setSelectedShareId(item.shareId);
        }}
      />
      <label htmlFor={`check-${index}`}>
        {item.title + "  "} ({item.productList.length})
      </label> */}

      <div className={styles["radio_options"]}>
        <div
          className={`${styles["select_radio"]} ${item.shareId === selectedShareId ? styles["active"] : ""
            }`}
        >
          <label className={styles["labl"]} htmlFor={`check-${index}`}>
            <input
              type="radio"
              name="radio_btns"
              id={`check-${index}`}
              value="1"
              autoComplete="off"
              onChange={() => {
                setRadioCheck(!isRadioCheck);
                setSelectedShareId(item.shareId);
              }}
            />
            <span className={styles["radio"]}></span>
            <span className={styles["text"]}>
              {item.title + "  "} ({item.productList.length})
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

Modal.defaultProps = {
  selectedProductIds: [],
};
export default Modal;
